import e from"react";import{ConditionalLink as t}from"./ConditionalLink.js";const r=(r,n,o=t)=>e.createElement(e.Fragment,null,n?n(r):e.createElement(o,{...r}));export{r as renderLinkElement};
